var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResilience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing---Web-Copy-6",
    transform: "translate(-552.000000, -549.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-10",
    transform: "translate(552.000000, 549.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.4521739,172.904348 C40.1201807,172.904348 43.9043478,169.120181 43.9043478,164.452174 C43.9043478,159.784167 40.1201807,156 35.4521739,156 C30.7841672,156 27,159.784167 27,164.452174 C27,165.605353 27,168.95939 27,174.514286 L30.2198758,172.904348 C32.7056618,172.904348 34.4497612,172.904348 35.4521739,172.904348 Z",
    id: "Oval",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4782609,117.956522 C48.4449463,117.956522 58.9565217,107.444946 58.9565217,94.4782609 C58.9565217,81.5115754 48.4449463,71 35.4782609,71 C22.5115754,71 12,81.5115754 12,94.4782609 C12,97.681535 12,106.998305 12,122.428571 L20.9440994,117.956522 C27.8490606,117.956522 32.6937811,117.956522 35.4782609,117.956522 Z",
    id: "Oval-Copy-7",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7173913,155.434783 C46.0547211,155.434783 54.4347826,147.054721 54.4347826,136.717391 C54.4347826,126.380062 46.0547211,118 35.7173913,118 C25.3800615,118 17,126.380062 17,136.717391 C17,139.271113 17,146.698649 17,159 L24.1304348,155.434783 C29.6352233,155.434783 33.4975421,155.434783 35.7173913,155.434783 Z",
    id: "Oval-Copy-8",
    stroke: "#000000",
    transform: "translate(35.717391, 138.500000) scale(-1, 1) translate(-35.717391, -138.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9795491,106.109409 L79,87.5 L79,87.5 C75.6666667,82.6686199 74,79.0019533 74,76.5 C74,40.5 103.413536,23.9995838 124.5,23.9995838 C159.5,23.9995838 179,44 184.5,59 C190,74 187.058273,99.1200949 175,107 C161.232318,115.996979 176.628405,134.673468 166.5,137.5 C153.158142,141.223309 140.971536,152.888981 129.940183,172.497014 L129.940182,172.497013 C129.398586,173.45969 128.179133,173.801044 127.216456,173.259448 C126.747764,172.995764 126.405008,172.554441 126.265536,172.035067 C123.065104,160.117097 118.976592,151.772074 114,147 C105.538405,138.886142 88.5474225,153.82268 82.5,140 C80.1666667,134.666667 79,125.5 79,112.5 L69.3960132,107.46934 C68.9067819,107.213076 68.7179246,106.608733 68.9741886,106.119502 C68.9759562,106.116127 68.977743,106.112763 68.9795491,106.109409 Z",
    id: "Path-5",
    stroke: "#000000",
    strokeWidth: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResilience);
export default __webpack_public_path__ + "static/media/resilience.f2d1ee1ba1cdda7957c1944483bce61b.svg";
export { ForwardRef as ReactComponent };